import * as Yup from "yup"
import { useFormik } from "formik"

export const formikClientForOtherPage = (options) => {
  const { handleSave } = options || {}
  return useFormik({
    initialValues: {
      client_name: '',
      client_description: '',
      client_address: '',
      pic_name: '',
      phone_number: '',
      pic_country_id: '',
      pic_job_position: '',
      pic_email_address: '',
      pic_department: '',
      pic_additional_notes: '',
      client_country_id: '',
      client_province_id: '',
      client_city_id: '',
      client_district_id: '',
      client_subdistrict_id: '',
      client_postal_code: '',
    },
    validationSchema: Yup.object().shape({
      client_name: Yup.string()
        .required("Please enter client name."),
      client_description: Yup.string()
        .required("Please enter client description."),
      client_address: Yup.string()
        .required("Please enter client address."),
      pic_name: Yup.string()
        .required("Please enter main point of contact name."),
      phone_number: Yup.string()
        .required("Please enter main point of contact contact number."),
      pic_country_id: Yup.string().required("Please enter main point of contact contact number country."),
      client_country_id: Yup.string().required("Please select client country."),
      pic_job_position: Yup.string()
        .required("Please enter main point of contact job position."),
      pic_email_address: Yup.string()
        .required("Please enter main point of contact email address.")
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      handleSave(values)
      setSubmitting(false)
    },
  });
}

export const formikProjectForOtherPage = (options) => {
  const { handleSave } = options || {}
  return useFormik({
    initialValues: {
      project_name: '',
      project_value: '',
      project_tax_value: '',
      project_description: '',
      project_start_date: '',
      project_end_date: '',
      client_value: null,
    },
    validationSchema: Yup.object().shape({
      project_name: Yup.string()
        .required("Please enter project name."),
      project_value: Yup.string()
        .required("Please enter project value."),
      project_tax_value: Yup.string()
        .required("Please enter project tax value."),
      project_description: Yup.string()
        .required("Please enter project description."),
      project_start_date: Yup.string()
        .required("Please select project start date."),
      project_end_date: Yup.string()
        .required("Please select project end date."),
      client_value: Yup.object().shape({
        label: Yup.string().required('Please select client name.')
      }).required('Please select client name.'),
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      handleSave(values)
      setSubmitting(false)
    },
  });
}